import { h } from 'preact';

export default (props) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clip-path="url(#clip0_9700_346857)">
			<path d="M7.99998 1.33301C9.6675 3.15858 10.6151 5.5277 10.6666 7.99967C10.6151 10.4717 9.6675 12.8408 7.99998 14.6663M7.99998 1.33301C6.33246 3.15858 5.38481 5.5277 5.33331 7.99967C5.38481 10.4717 6.33246 12.8408 7.99998 14.6663M7.99998 1.33301C4.31808 1.33301 1.33331 4.31778 1.33331 7.99967C1.33331 11.6816 4.31808 14.6663 7.99998 14.6663M7.99998 1.33301C11.6819 1.33301 14.6666 4.31778 14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663M1.66666 5.99967H14.3333M1.66665 9.99967H14.3333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
		</g>
		<defs>
			<clipPath id="clip0_9700_346857">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);